import { useMemo } from 'react';
import type { DealData } from '@types';
import { SalesDealDetails } from '@/components/AccountDetails/components/DealDetails/SalesDealDetails';
import { TaxesDealDetails } from '@/components/AccountDetails/components/DealDetails/TaxesDealDetails';
import {
  SALES_DEAL_PIPELINE,
  TAXES_DEAL_PIPELINES,
} from '../../../../shared/contants/hubspotConstants';

interface AccountDealAccordionListProps {
  deals: DealData[];
  fontSize: string;
  showHubspotLink?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export function AccountDealAccordionList({
  deals,
  fontSize,
  showHubspotLink,
}: AccountDealAccordionListProps) {
  const linkValidStatus = ['closedwon', 'churned'];

  const sortDealsByClosedDate = (prev: DealData, curr: DealData) => {
    if (prev.closed_date === null && curr.closed_date === null) {
      return 0;
    }
    if (prev.closed_date === null) {
      return 1;
    }
    if (prev.closed_date === null) {
      return -1;
    }
    return (
      new Date(curr.closed_date).getTime() -
      new Date(prev.closed_date).getTime()
    );
  };

  const filteredSalesDeals = useMemo(
    () =>
      deals
        ?.filter(
          (deal) =>
            deal?.status &&
            linkValidStatus.includes(deal.status) &&
            deal?.pipeline === SALES_DEAL_PIPELINE
        )
        .sort(sortDealsByClosedDate),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [deals]
  );

  const filteredTaxesDeals = useMemo(
    () =>
      deals
        ?.filter(
          (deal) =>
            deal?.status &&
            linkValidStatus.includes(deal.status) &&
            TAXES_DEAL_PIPELINES.includes(deal?.pipeline)
        )
        .sort(sortDealsByClosedDate),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [deals]
  );
  const dealsAmount =
    (filteredSalesDeals ? filteredSalesDeals.length : 0) +
    (filteredTaxesDeals ? filteredTaxesDeals.length : 0);

  if (dealsAmount <= 0) {
    return <h2>No Deals</h2>;
  }

  return (
    <>
      {dealsAmount > 0 && (
        <div>
          <hr className='mt-6 mb-2' />
          <h2 className='text-xl  my-2 capitalize'>Deals</h2>
        </div>
      )}
      {filteredSalesDeals?.map((deal: DealData, index: number) => (
        <SalesDealDetails
          deal={deal}
          key={`sales_deal_${deal.deal_id}`}
          index={index}
          fontSize={fontSize}
          showHubspotLink={showHubspotLink}
        />
      ))}
      {filteredTaxesDeals?.map((deal: DealData, index: number) => (
        <TaxesDealDetails
          deal={deal}
          key={`taxes_deal_${deal.deal_id}`}
          index={index}
          fontSize={fontSize}
          showHubspotLink={showHubspotLink}
        />
      ))}
    </>
  );
}
